import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, BookHeart } from "lucide-react";
import { api } from "@/lib/api";
import { subjectStyle } from "@/lib/subjects";

const weekLabel = (iso) => {
  const d = new Date(`${iso}T12:00:00`);
  const end = new Date(d); end.setDate(d.getDate() + 6);
  const f = (x) => x.toLocaleDateString("en-GB", { day: "numeric", month: "short" });
  return `Week of ${f(d)} – ${f(end)}`;
};

export default function SubjectTimeline() {
  const { name } = useParams();
  const subject = decodeURIComponent(name || "");
  const [t, setT] = useState(null);
  useEffect(() => { api.get("/daylog/subject", { params: { name: subject } }).then((r) => setT(r.data ?? false)).catch(() => setT(false)); }, [subject]);
  const weeks = Array.isArray(t?.weeks) ? t.weeks : [];
  const colour = subjectStyle(subject).dot;
  return (
    <main data-testid="subject-timeline-page" className="mx-auto max-w-3xl px-4 sm:px-6 py-8 sm:py-12 space-y-6">
      <Link to="/daylog" data-testid="timeline-back" className="inline-flex items-center gap-1.5 text-sm font-semibold text-slate-600 hover:text-white"><ArrowLeft className="w-4 h-4" />Day log</Link>
      <div>
        <p className="eyebrow flex items-center gap-2"><BookHeart className="w-4 h-4" />Subject timeline</p>
        <h1 data-testid="timeline-subject" className="mt-2 font-display text-4xl sm:text-5xl text-white leading-none">{subject}</h1>
        {t && <p className="mt-2 text-sm text-slate-600">{t.total} lesson{t.total === 1 ? "" : "s"} logged across {weeks.length} week{weeks.length === 1 ? "" : "s"}</p>}
      </div>
      {t === null && <div className="h-48 rounded-3xl bg-surface animate-pulse" />}
      {t && !weeks.length && <p data-testid="timeline-empty" className="rounded-3xl border-2 border-dashed border-slate-200 p-8 text-center text-slate-500">Nothing logged for {subject} yet.</p>}
      <ol className="space-y-6">
        {weeks.map((w) => (
          <li key={w.week_start} data-testid={`timeline-week-${w.week_start}`}>
            <p className="font-mono text-xs font-bold uppercase tracking-widest text-gold-300">{weekLabel(w.week_start)}</p>
            <ul className="mt-3 relative border-l-2 pl-5 space-y-3" style={{ borderColor: colour }}>
              {w.items.map((it, i) => (
                <li key={`${it.date}-${it.start}-${i}`} className="relative">
                  <span className="absolute -left-[27px] top-4 w-3 h-3 rounded-full border-2 border-surface-deep" style={{ backgroundColor: colour }} />
                  <div className="card !rounded-2xl p-3.5">
                    <p className="text-xs font-bold text-slate-500">{new Date(`${it.date}T12:00:00`).toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "short" })}{it.start && ` · ${it.start}`}</p>
                    <p className="mt-1 text-sm text-slate-800 whitespace-pre-wrap">{it.text}</p>
                  </div>
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ol>
    </main>
  );
}
